export default __webpack_public_path__ + "static/media/FountainWorksPosterSpinny.7b431ff3.png";